import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header flex-column" }
const _hoisted_4 = { class: "d-flex w-100" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = {
  key: 0,
  class: "w-100"
}
const _hoisted_7 = {
  key: 1,
  class: "w-100"
}
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "m-2 my-3 form-group" }
const _hoisted_11 = { class: "m-2" }
const _hoisted_12 = { class: "my-2 form-check" }
const _hoisted_13 = {
  id: "template-project-menu",
  class: "my-2 new-project-menu"
}
const _hoisted_14 = { class: "m-2" }
const _hoisted_15 = { class: "my-2 form-check" }
const _hoisted_16 = {
  id: "upload-project-menu",
  class: "my-1 new-project-menu"
}
const _hoisted_17 = { class: "custom-file" }
const _hoisted_18 = {
  id: "project-file-label",
  class: "custom-file-label"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "table table-hover m-2 my-2" }
const _hoisted_21 = { class: "scrollable" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "modal-footer d-flex justify-content-end" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resource_item = _resolveComponent("resource-item")!
  const _component_BtnSubmit = _resolveComponent("BtnSubmit")!

  return (_openBlock(), _createElementBlock("div", {
    class: "project-new-modal modal fade",
    tabindex: "-1",
    onKeydown: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.applyShortcut && _ctx.applyShortcut(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "modal-title flex-fill" }, "New Project", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.step === _ctx.WizardStep.RESOURCES)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("p", { class: "help-text" }, "Choose resources of your project.", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.step === _ctx.WizardStep.GENERAL_PROPS)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("p", { class: "help-text" }, "You can share files on GanttProject Cloud from desktop GanttProject application, by uploading from your browser or by creating new project from template.", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.step === _ctx.WizardStep.GENERAL_PROPS)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "project-menu-label" }, "Project filename", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.projectFilename) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.projectFilename]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      id: "template-project-radio",
                      class: "my-1 form-check-input",
                      type: "radio",
                      name: "new-project-type",
                      value: "#template-project-menu",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedMenu) = $event)),
                      checked: ""
                    }, null, 512), [
                      [_vModelRadio, _ctx.selectedMenu]
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("label", {
                      class: "project-menu-label form-check-label",
                      for: "template-project-radio"
                    }, "From template", -1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("select", {
                      id: "template-project-select",
                      class: "form-control custom-select",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTemplateId) = $event)),
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSelectedTemplateId && _ctx.onSelectedTemplateId(...args)))
                    }, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("option", {
                        id: "tpl-builtin-0",
                        value: "tpl-builtin-0",
                        selected: ""
                      }, "Empty Project", -1),
                      _createElementVNode("option", {
                        id: "tpl-builtin-1",
                        value: "tpl-builtin-1"
                      }, "House Building Sample", -1)
                    ]))], 512), [
                      [_vModelSelect, _ctx.selectedTemplateId]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      id: "upload-project-radio",
                      class: "form-check-input",
                      type: "radio",
                      name: "new-project-type",
                      value: "#upload-project-menu",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedMenu) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.selectedMenu]
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("label", {
                      class: "project-menu-label form-check-label",
                      for: "upload-project-radio"
                    }, "Upload", -1))
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("input", {
                        id: "project-file-input",
                        class: "custom-file-input",
                        type: "file",
                        accept: ".gan",
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                        disabled: ""
                      }, null, 32),
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.projectFileLabel), 1),
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "invalid-feedback" }, [
                        _createTextVNode(" Please choose a file with "),
                        _createElementVNode("code", null, ".gan"),
                        _createTextVNode(" extension.")
                      ], -1))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.step === _ctx.WizardStep.RESOURCES)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("table", _hoisted_20, [
                  _createElementVNode("tbody", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (r, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "w-100",
                        onClick: ($event: any) => (_ctx.toggleResource(`checkbox-${i}`))
                      }, [
                        _createElementVNode("td", {
                          class: _normalizeClass(["centered-checkbox", i === 0 ? 'borderless-top' : ''])
                        }, [
                          _withDirectives(_createElementVNode("input", _mergeProps({ ref_for: true }, {'id': `checkbox-${i}`}, {
                            type: "checkbox",
                            value: r,
                            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedResources) = $event))
                          }), null, 16, _hoisted_23), [
                            [_vModelCheckbox, _ctx.selectedResources]
                          ])
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass(i === 0 ? 'borderless-top' : '')
                        }, [
                          _createVNode(_component_resource_item, { resource: r }, null, 8, ["resource"])
                        ], 2)
                      ], 8, _hoisted_22))
                    }), 256))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "btn btn-link",
            type: "button",
            disabled: _ctx.step === _ctx.WizardStep.GENERAL_PROPS,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setStep(_ctx.WizardStep.GENERAL_PROPS)))
          }, "Back", 8, _hoisted_25),
          _createElementVNode("button", {
            class: "btn btn-link",
            type: "button",
            disabled: _ctx.step === _ctx.WizardStep.RESOURCES,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setStep(_ctx.WizardStep.RESOURCES)))
          }, "Next", 8, _hoisted_26),
          _createVNode(_component_BtnSubmit, {
            title: _ctx.submitButtonTitle,
            spinner: "",
            ref: "submitButton",
            "submit-handler": _ctx.onSubmit
          }, null, 8, ["title", "submit-handler"])
        ])
      ])
    ])
  ], 32))
}